import React, { useState } from 'react'
import { toast, ToastContainer } from 'react-toastify';
import { Button, Col, Container, Row } from 'reactstrap';
import ToggleButton from "react-toggle-button";
import { addFAQs } from '../../../stores/services/knowledgebase.service';

function AddFAQs(props) {
    const {
        refreshData,
        setRefreshData,
        setAddModalFlag
    } = props
    const [question, setQuestion] = useState<string>("")
    const [answers, setAnswers] = useState<string>("")
    const [status, setStatus] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)
    const email = sessionStorage.getItem("email") || "";
    const amc_code = sessionStorage.getItem("amc_code") || "";
    const borderRadiusStyle = { borderRadius: 2 };

    const handleAdd = async () => {
        if (question?.trim() == "") {
            toast.error("Question field can not be empty")
            return
        }
        if (answers?.trim() == "") {
            toast.error("Answer field can not be empty")
            return
        }
        setLoading(false)
        try {
            let res = await addFAQs(
                email,
                amc_code,
                question || "",
                answers || "",
                status?.toString()
            )
            if (res.status == 200 && res.data.status == 200) {
                toast.success(res.data.message)
                setRefreshData(!refreshData)
            }
        } catch (error) {
            toast.error("Error Creating FAQs")
        }
        finally {
            setLoading(false)
            setAddModalFlag(false)
        }
    }

    return (
        <Col md="12" className='px-0'>
            <Container fluid>
                <Row>
                    <Col md="12" className='px-0'>
                        <div className="form-group">
                            <label>Question</label>
                            <input
                                className="form-control"
                                placeholder='Enter Question'
                                value={question}
                                onChange={(e) => {
                                    setQuestion(e.target.value);
                                }}
                            />
                        </div>
                        {/* {nameError === true ? (
                                  <p className="error-labels">Name is Required.</p>
                                ) : (
                                  ""
                                )} */}
                    </Col>
                    <Col md="12" className='px-0'>
                        <div className="form-group">
                            <label>Answer</label>
                            <textarea
                                rows={3}
                                className="form-control"
                                placeholder='Enter Answer'
                                value={answers}
                                onChange={(e) => {
                                    setAnswers(e.target.value);
                                }}
                            />
                        </div>
                    </Col>
                    <Col md="12" className='px-0'>
                        <div className="form-group">
                            <label>Status</label>
                            <ToggleButton
                                inactiveLabel=""
                                activeLabel=""
                                value={status}
                                thumbStyle={borderRadiusStyle}
                                trackStyle={borderRadiusStyle}
                                onToggle={() => {
                                    setStatus(!status)
                                }}
                            />
                        </div>
                    </Col>
                </Row>
                <Row className='d-flex justify-content-between'>
                    <Button
                        onClick={() => setAddModalFlag(false)}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={() => handleAdd()}
                        disabled={loading}
                        color='primary'>
                        Create
                    </Button>
                </Row>
            </Container>
        </Col>
    )
}

export default AddFAQs